import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Control Total Hoy',
    desc: 'Entrenamiento progresivo de 21 días.',
    color: 'from-gray-800 to-black'
  }, {
    num: '02',
    title: 'En Tu Primer Encuentro',
    desc: 'Protocolo complementario para ayudarte a sentir mayor tranquilidad desde el inicio.',
    color: 'from-blue-900/40 to-black'
  }, {
    num: '03',
    title: 'Aplicación práctica',
    desc: 'Implementación gradual y construcción de confianza.',
    color: 'from-red-900/40 to-black'
  }];
  return <section className="py-24 bg-black relative" data-id="element-72">
      <div className="container mx-auto px-4 relative z-10" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-74">
          <h2 className="text-5xl md:text-6xl font-teko font-bold text-white mb-4" data-id="element-75">
            UN SISTEMA DISEÑADO PARA ACOMPAÑARTE{' '}
            <span className="text-electric-blue" data-id="element-76">PASO A PASO</span>
          </h2>
        </motion.div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-77">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-white/10 -translate-y-1/2 z-0" data-id="element-78"></div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="relative z-10" data-id="element-79">
              <div className={`bg-gradient-to-b ${step.color} border border-white/10 p-8 rounded-2xl h-full flex flex-col items-center text-center hover:border-white/30 transition-colors`} data-id="element-80">
                <div className="w-20 h-20 rounded-full bg-black border-2 border-electric-blue flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(0,170,255,0.3)]" data-id="element-81">
                  <span className="text-3xl font-teko font-bold text-white" data-id="element-82">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-83">
                  {step.title}
                </h3>
                <p className="text-gray-400 font-medium text-lg leading-relaxed" data-id="element-84">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}